/* eslint-disable no-case-declarations */
import { SET_CURRENT_DASHBOARD } from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  currentDashboard: '',
};

/**
 * dispatched the user data to the store
 * @param  { Object } state  default state
 * @param  { Object } action dispacthed action from middleware
 */
export default function getCurrentDashboard(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD:
      const data = {};
      data.currentDashboard = action.currentDashboard;
      return { ...state, ...data };
    default: return state;
  }
}
